export const DEFAULT_MIN_PASSWORD_LENGTH = 7;
export const REGISTER_USERNAME_MAX = 16;
export const LOGIN_USERNAME_MAX = 25;
export const USERNAME_MIN = 5;
export const REGISTER_USERNAME_MIN_LETTERS = 2;
export const REGISTER_USERNAME_MAX_DIGITS = 9;
const LETTER = /[A-Za-z]/;
export const isValidEmail = (value) => {
    if (!value)
        return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
};
const isAlphanumericUsername = (username, max) => {
    if (username.length < USERNAME_MIN || username.length > max)
        return false;
    if (!/^[A-Za-z0-9]+$/.test(username))
        return false;
    const letterCount = (username.match(/[A-Za-z]/g) ?? []).length;
    if (letterCount < REGISTER_USERNAME_MIN_LETTERS)
        return false;
    const digitCount = (username.match(/[0-9]/g) ?? []).length;
    return digitCount <= REGISTER_USERNAME_MAX_DIGITS;
};
export const isValidRegisterUsername = (value) => {
    if (!value)
        return false;
    return isAlphanumericUsername(value.trim(), REGISTER_USERNAME_MAX);
};
/** Login usernames may carry a legacy `_` from pre-password-auth accounts (Adam, Slack). */
export const isValidLoginUsername = (value) => {
    if (!value)
        return false;
    const username = value.trim();
    if (username.length < USERNAME_MIN || username.length > LOGIN_USERNAME_MAX)
        return false;
    if (!/^[A-Za-z0-9_]+$/.test(username))
        return false;
    return LETTER.test(username);
};
/** Register-length username (5–16). Prefer isValidRegisterUsername at call sites. */
export const isValidUsername = (value) => {
    if (!value)
        return false;
    return isValidRegisterUsername(value);
};
export const isValidPassword = (value, minLength = DEFAULT_MIN_PASSWORD_LENGTH) => {
    if (!value)
        return false;
    if (value.length < minLength)
        return false;
    return /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value);
};
export const classifyIdentifier = (value) => {
    const identifier = value.trim();
    if (!identifier)
        return 'invalid';
    if (/^\d+$/.test(identifier))
        return 'phone';
    const atCount = (identifier.match(/@/g) ?? []).length;
    if (atCount > 1)
        return 'invalid';
    if (atCount === 1)
        return isValidEmail(identifier) ? 'email' : 'invalid';
    return isValidLoginUsername(identifier) ? 'username' : 'invalid';
};
export const isValidLoginIdentifier = (value) => {
    const kind = classifyIdentifier(value);
    return kind === 'email' || kind === 'username';
};
